// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"About_contentContainer__d3QCD","header":"About_header__3Emug","text":"About_text__2-tin","imageContainer":"About_imageContainer__3F5Y8"};